import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { sentNewsletter } from "../api/api";
import { Logo } from "./brand";
import Button from "./Button";
import WaveDivider from "./WaveDivider";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "Thanks for showing Interest!",
    email: "",
    phone: "",
    service: "",
    message: "The client is interested in getting updates",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const year = new Date().getFullYear();

  const footerdata = [
    {
      title: "Quick Links",
      subtitles: [
        { name: "Our Story", url: "/ourstory" },
        { name: "Our App", url: "/ourapp" },
        { name: "Events", url: "/events" },
        { name: "Become an Ally", url: "/becomeanally" },
        { name: "Partnerships", url: "/partnerships" },
        { name: "Resources", url: "/resources" },
      ],
    },
    {
      title: "Company",
      subtitles: [
        { name: "Blog", url: "/blog" },
        { name: "News/Update", url: "/news&updates" },
        { name: "Contact Us", url: "/contactus" },
      ],
    },
  ];

  const sociallogos = [
    {
      name: "facebook",
      imgpath: "/images/header/Facebook.svg",
      url: "https://www.facebook.com/share/17eZ7J3oY9/?mibextid=qi2Omg",
    },
    {
      name: "Instagram",
      imgpath: "/images/header/Instagram.svg",
      url: "https://www.instagram.com/socialspectrum2024?igsh=MW1jaWhzZnNlcHVzbw==",
    },
    {
      name: "LinkedIn",
      imgpath: "/images/header/LinkedIn.svg",
      url: "https://www.linkedin.com/company/socialspectrum/",
    },
    {
      name: "X",
      imgpath: "/images/header/X.svg",
      url: "https://x.com/SocialSpectrum4?s=08",
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    toast.success("Your details is being submitted");

    try {
      const response = await sentNewsletter(formData);
      if (response.message) {
        setFormData({
          email: "",
        });
        toast.success("Email submitted successfully!");
      } else if (response.error) {
        toast(
          response.error.message + ", Message could not be sent" ||
            "Failed to send message"
        );
      }
    } catch (err) {
      toast("An unexpected error occurred");
    }
  };

  return (
    <>
      <WaveDivider
        fromClassName="bg-surface-white"
        waveClassName="text-spectrum-blue"
      />
      <footer className="relative bg-spectrum-blue text-surface-white pt-16 pb-12 w-full text-left overflow-hidden">
        {/* Glows sit below the top edge so the wave's Spectrum Blue fill stays exact */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute bottom-0 right-0 h-72 w-72 rounded-full bg-heart-teal opacity-10 blur-3xl"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute bottom-16 left-0 h-64 w-64 rounded-full bg-sunshine opacity-10 blur-3xl"
        />

        <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10 flex flex-col gap-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5 flex flex-col items-start">
              <Link
                to="/"
                className="mb-5 inline-block focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine rounded-brand"
                aria-label="Social Spectrum Home"
              >
                <span className="bg-surface-white p-2.5 rounded-brand inline-flex shadow-sm">
                  <Logo variant="primary" height={44} compact />
                </span>
              </Link>

              <p className="text-sm text-white/90 mb-6 max-w-sm font-headline">
                To receive updates from the Social Spectrum team, leave your email
                here.
              </p>

              <form
                onSubmit={handleSubmit}
                method="post"
                className="w-full max-w-md flex flex-col sm:flex-row gap-2.5 mb-6"
              >
                <label htmlFor="footer-newsletter-email" className="sr-only">
                  Email address
                </label>
                <input
                  id="footer-newsletter-email"
                  type="email"
                  placeholder="Enter your email address"
                  required
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="bg-surface-white text-ink placeholder-village px-4 py-3 rounded-brand text-sm font-headline w-full border-none shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine"
                />
                <Button
                  type="submit"
                  variant="accent"
                  size="sm"
                  className="shrink-0 !text-sm !px-6 !py-3"
                >
                  Subscribe
                </Button>
              </form>

              <div className="flex items-center gap-3 flex-wrap">
                <Link
                  to="https://apps.apple.com/us/app/social-spectrum/id6473112455"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => window.plausible("App Store Click")}
                  className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 border border-white/30 px-3.5 py-2.5 rounded-brand text-surface-white transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine"
                >
                  <span className="text-left leading-none">
                    <span className="block text-[10px] text-white/75">
                      Download on the
                    </span>
                    <span className="font-headline font-semibold text-xs text-surface-white">
                      App Store
                    </span>
                  </span>
                </Link>
                <Link
                  to="https://play.google.com/store/apps/details?id=com.social_spectrum.mobile"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => window.plausible("Play Store Click")}
                  className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 border border-white/30 px-3.5 py-2.5 rounded-brand text-surface-white transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine"
                >
                  <span className="text-left leading-none">
                    <span className="block text-[10px] text-white/75">
                      GET IT ON
                    </span>
                    <span className="font-headline font-semibold text-xs text-surface-white">
                      Play Store
                    </span>
                  </span>
                </Link>
              </div>
            </div>

            {footerdata.map((items) => (
              <div
                key={items.title}
                className="lg:col-span-2 flex flex-col items-start"
              >
                <h2 className="font-headline font-bold text-sunshine text-sm mb-4">
                  {items.title}
                </h2>
                <ul className="space-y-2.5 text-sm font-headline">
                  {items.subtitles.map((titles) => (
                    <li key={titles.url}>
                      <Link
                        to={titles.url}
                        className="text-surface-white hover:text-sunshine transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine rounded-sm"
                      >
                        {titles.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="lg:col-span-3 flex flex-col items-start">
              <h2 className="font-headline font-bold text-sunshine text-sm mb-4">
                Contact & Support
              </h2>
              <ul className="space-y-2 text-sm font-headline mb-6">
                <li>
                  <a
                    href="mailto:admin@socialspectrum.org"
                    className="text-surface-white hover:text-sunshine transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine rounded-sm"
                  >
                    admin@socialspectrum.org
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:archana.akhaury@socialspectrum.org"
                    className="text-surface-white hover:text-sunshine transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine rounded-sm"
                  >
                    archana.akhaury@socialspectrum.org
                  </a>
                </li>
              </ul>

              <p className="text-xs font-semibold text-sunshine mb-2.5 font-headline">
                Follow us on
              </p>
              <div className="flex items-center gap-3">
                {sociallogos.map((items) => (
                  <Link
                    to={items.url}
                    key={items.name}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={items.name}
                    className="group w-9 h-9 rounded-brand bg-white/15 hover:bg-sunshine border border-white/20 hover:border-sunshine flex items-center justify-center transition-all focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine"
                  >
                    <img
                      src={process.env.PUBLIC_URL + items.imgpath}
                      alt=""
                      className="w-4 h-4 brightness-0 invert group-hover:invert-0 transition-[filter]"
                    />
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-white/20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/75 font-headline">
            <p>{`© ${year} SOCIAL SPECTRUM PTY LTD ABN 90 677 005 908`}</p>
            <div className="flex items-center gap-5">
              <Link
                to="/privacy"
                className="text-white/80 hover:text-sunshine transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine rounded-sm"
              >
                Privacy Policy
              </Link>
              <span aria-hidden="true" className="text-white/80">
                •
              </span>
              <Link
                to="/terms_and_conditions"
                className="text-white/80 hover:text-sunshine transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunshine rounded-sm"
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
